/*
 * Created on 27.02.19 14:21
 *
 * Copyright(c) 1995 - 2019 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { Observable, Subject } from 'rxjs';

/**
 * Ein Publish–subscribe Service, der global für alle für Verfügung steht.
 * Wird momentan für SearchEvent verwendet.
 */
export class PortalEventService {
    private event$ = new Subject<PortalEvent>();

    next(event: PortalEvent) {
        this.event$.next(event);
    }

    get(): Observable<PortalEvent> {
        return this.event$.asObservable();
    }
}

export class PortalEvent {
}

export class SearchEvent implements PortalEvent {

    keyword: string;

    category: string;

    resultsCount: number = undefined;

    constructor(keyword: string, category: string, resultsCount: number) {
        this.keyword = keyword;
        this.category = category;
        this.resultsCount = resultsCount;
    }
}

export class TrackEvent implements PortalEvent {

    category: string;

    action: string;

    name?: string;

    value?: string;

    constructor(category: string, action: string, name?: string, value?: string) {
        this.category = category;
        this.action = action;
        this.name = name;
        this.value = value;
    }
}

export class TrackDownloadEvent implements PortalEvent {

    category: string;

    name: string;

    constructor(category: string, name: string) {
        this.category = category;
        this.name = name;
    }
}
